import { PROXY_URL } from '@/config';
import { ElMessage } from '@qsxy/element-plus-react';

/**
 * 获取当前页面的ip + 端口 + 应用名
 * @returns {String} ip + 端口 + 应用名
 */
export function getContexPath() {
	const currentPagepath = location.href;
	const pathName = window.document.location.pathname;
	if (pathName === '/') {
		return location.origin + location.pathname;
	}
	const pos = currentPagepath.indexOf(pathName);
	const localhostPath = currentPagepath.substring(0, pos);
	const projectName = pathName.substring(0, pathName.substr(1).indexOf('/') + 1);
	return localhostPath + projectName;
}

export function escapeHtml(html, defVal?: any) {
	if (html) {
		const text = html
			.replace(/<style\[^>\]*?>\[\s\S]*?<\/style >/g, '')
			.replace(/<[^>]+>/g, '')
			.replace(/\s*|\t|\r|\n/g, '');
		return text;
	}
	return defVal || '';
}

/**
 * 深度合并对象
 * @param {*} target 目标对象
 * @param {*} source 合并的源对象
 */
export function deepExtend(target, source) {
	if (Object.prototype.toString.call(target) === '[object Object]' && Object.prototype.toString.call(source) === '[object Object]') {
		for (const prop in source) {
			//target无值,都有取source
			if (!target[prop]) {
				target[prop] = source[prop];
			} else {
				//递归赋值
				target[prop] = deepExtend(target[prop], source[prop]);
			}
		}
	} else if (Object.prototype.toString.call(target) === '[object Array]' && Object.prototype.toString.call(source) === '[object Array]') {
		// 两个都是数组，进行合并
		// target = target.concat(source);
		target = source;
	} else {
		//其他情况，取source的值
		target = source;
	}
	return target;
}

/**
 * 获取url中的参数值
 * @param {String} variable 参数名
 * @param {String} url 检索的URL,非必须
 */
export function getQueryVariable(variable, url) {
	if (!url) {
		url = location.href;
	}
	if (url.indexOf('?') == -1) {
		return;
	}
	const query = url.split('?')[1];
	const vars = query.split('&');
	for (let i = 0; i < vars.length; i++) {
		const pair = vars[i].split('=');
		if (pair[0] == variable) {
			return pair[1];
		}
	}
}

export const arrayMove = (array: Array<any>, from: number, to: number) => {
	array = array.slice();
	array.splice(to < 0 ? array.length + to : to, 0, array.splice(from, 1)[0]);
	return array;
};

export const showLoading = (message: string) => {
	return ElMessage({
		message,
		duration: 0,
		iconClass: 'far fa-spinner fa-spin',
	});
};

export const getBaseUrl = () => {
	return process.env.NODE_ENV === 'production' ? getContexPath() : PROXY_URL;
};

/**
 * 将数值四舍五入后格式化.
 * @param num 数值(Number或者String)
 * @param cent 要保留的小数位(Number)
 * @return 格式的字符串,如'1,234,567.45'
 * @type String
 */
export function formatNumber(num, cent) {
	let cents;
	num = parseFloat(num); // 去掉单位数量后缀
	num = num.toString().replace(/\$|\\,/g, '');

	// 检查传入数值为数值类型
	if (isNaN(num)) {
		return '';
	}

	// 获取符号(正/负数)
	const sign = num == (num = Math.abs(num));

	num = Math.floor(num * Math.pow(10, cent) + 0.50000000001); // 把指定的小数位先转换成整数.多余的小数位四舍五入
	cents = num % Math.pow(10, cent); // 求出小数位数值
	num = Math.floor(num / Math.pow(10, cent)).toString(); // 求出整数位数值
	cents = cents.toString(); // 把小数位转换成字符串,以便求小数位长度

	// 补足小数位到指定的位数
	while (cents.length < cent) {
		cents = '0' + cents;
	}

	if (cent > 0) {
		return (sign ? '' : '-') + num + '.' + cents;
	} else {
		return (sign ? '' : '-') + num;
	}
}
